import ObjectCreationValidator from '@/entities/validators/ObjectCreationValidator'
import { InvoiceI } from '@/modules/myInvoices/types/api/Invoice'
import { formatDate } from '@/utils'
import { ChipsColorI } from '@/typescript/types/ui-components/BaseChipsI'

export default class Invoice {
  id: number
  userid: number
  firstname: string
  lastname: string
  companyname: string
  invoicenum: string
  date: string
  duedate: string
  datepaid: string
  last_capture_attempt: string
  date_refunded: string
  date_cancelled: string
  subtotal: string
  credit: string
  tax: string
  tax2: string
  total: string
  taxrate: string
  taxrate2: string
  status: string
  paymentmethod: string
  paymethodid: number
  notes: string
  created_at: string
  updated_at: string
  currencycode: string
  currencyprefix: string
  currencysuffix: string
  constructor(invoice: InvoiceI) {
    this.id = invoice.id
    this.userid = invoice.userid
    this.id = invoice.id
    this.userid = invoice.userid
    this.firstname = invoice.firstname
    this.lastname = invoice.lastname
    this.companyname = invoice.companyname
    this.invoicenum = invoice.invoicenum
    this.date = invoice.date
    this.duedate = invoice.duedate
    this.datepaid = invoice.datepaid
    this.last_capture_attempt = invoice.last_capture_attempt
    this.date_refunded = invoice.date_refunded
    this.date_cancelled = invoice.date_cancelled
    this.subtotal = invoice.subtotal
    this.credit = invoice.credit
    this.tax = invoice.tax
    this.tax2 = invoice.tax2
    this.total = invoice.total
    this.taxrate = invoice.taxrate
    this.taxrate2 = invoice.taxrate2
    this.status = invoice.status
    this.paymentmethod = invoice.paymentmethod
    this.paymethodid = invoice.paymethodid
    this.notes = invoice.notes
    this.created_at = invoice.created_at
    this.updated_at = invoice.updated_at
    this.currencycode = invoice.currencycode
    this.currencyprefix = invoice.currencyprefix
    this.currencysuffix = invoice.currencysuffix

    ObjectCreationValidator.validate(this)
  }

  /* The register's date columns are numeric ISO (2026-09-11), as the design draws them and as
     every other date in the client area reads. */
  get invoiceDateFormatted() {
    return formatDate(this.date)
  }
  get dueDateFormatted() {
    return formatDate(this.duedate)
  }
  /**
   * Badge tone per the My Invoices design's STATUS_BADGE map. The tones are BaseChips
   * vocabulary, which BfStatusChip translates into the design system's badge variants:
   * `green` → success, `gray` → light-grey, `dark_orange` → grey, `orange` → pending,
   * `red` → error. Cancelled and Refunded are settled, ended states rather than warnings,
   * so they take grey instead of the red the fallback used to give them.
   */
  get getChipsColor(): ChipsColorI {
    switch (this.status) {
      case 'Paid':
        return 'green'
      case 'Unpaid':
        return 'gray'
      case 'Cancelled':
      case 'Refunded':
        return 'dark_orange'
      // WHMCS writes "Payment Pending"; the design names the state "Pending".
      case 'Pending':
      case 'Payment Pending':
        return 'orange'
      default:
        return 'red'
    }
  }
}
